import useAppFolderAndTabStore from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import CloseProjectByAdmin from '../../../page/requestNewProject/closeProjectByAdmin/closeProjectByAdmin'
import * as Constants from '../../../../../../constants/constants'
import React from 'react'
import ResultOfConsider from '../../../page/resultOfConsider/closeProjectByAdmin/resultOfConsider'

type ResearcherViewType = ResearcherType //& ReturnType<typeof useResearcher>
const ResearcherView: React.FC<ResearcherViewType> = (props) => {
    const { callbackSaveComplete } = props
    const appFolderAndTabStore = useAppFolderAndTabStore()
    const manageProjectStore = useManageProjectStore()
    const renderPage = () => {
        const tabID = appFolderAndTabStore?.tabSelected?.id
        switch (tabID) {
            // case Constants.menuTab.tab1.id: //หน้าตรวจสอบ
            case Constants.menuTab.tab21.id: //หน้ายื่นโครงการ
                return (
                    <CloseProjectByAdmin
                        projectData={manageProjectStore?.projectData ?? undefined}
                        onSaveComplete={callbackSaveComplete}
                    />
                )
            case Constants.menuTab.tab23.id:
                return <ResultOfConsider projectData={manageProjectStore?.projectData ?? undefined} />
            default:
                return <></>
        }
    }
    return <> {renderPage()} </>
}

export type ResearcherType = {
    projectMode: 'CREATE' | 'EDIT'
    callbackSaveComplete?: (resStatus: number, isDraft: boolean) => void
}
const Researcher: React.FC<ResearcherType> = (props) => {
    return <ResearcherView {...props} />
}
export default Researcher
